// src/services/base.api.ts
// RTK Query base API — all feature APIs inject their endpoints here.
import { createApi } from '@reduxjs/toolkit/query/react'
import { axiosBaseQuery } from './axios.base.query'

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery,
  tagTypes: ['Auth', 'Institution', 'Staff', 'Subject', 'PaymentPolicy', 'Student', 'Exam', 'Certificate', 'Payout', 'PayoutSchedule', 'Migration', 'Reporting', 'Notification', 'AppUpdate'],
  endpoints: () => ({}),
})
